<script>
import characters from '@/config/characters'

import GlitchedImage from './GlitchedImage'

export default {
  name: 'CharacterPortrait',

  components: {
    GlitchedImage
  },

  props: {
    characterSlug: {
      type: String,
      required: true,
      validator (characterSlug) {
        return characters[characterSlug]
      }
    }
  },

  computed: {

    character () {
      return characters[this.characterSlug]
    },

    portrait () {
      return this.character.portrait
    }

  }

}
</script>

<template>
  <glitched-image
    :src="portrait"
    class="c-character-portrait"
  />
</template>

<style lang="scss">

.c-character-portrait {
  opacity: 0.75;
  filter: grayscale(0.85);
}

</style>
